import React from 'react';
import Chip, { ChipProps } from '@mui/material/Chip';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import {
  acceptedStatuses,
  rejectedStatuses
} from 'modules/conversations/constants';
import {
  ConversationStatus,
  MeetingBookingStatus
} from 'generated-graphql/types';
import { CampaignType } from 'services/campaign/types';
import { getCampaignDisplayStatus } from '../utils/getCampaignDisplayStatus';
import { badgeChipSx } from 'theme/components/chip';
import { screeningStatusChipSx } from '../styles';

type Props = {
  status: ConversationStatus;
  campaignType?: CampaignType | null;
  meetingBookingStatus?: MeetingBookingStatus | null;
};

export const getScreeningStatusChipProps = ({
  status: conversationStatus,
  campaignType,
  meetingBookingStatus
}: Props): ChipProps | null => {
  const status = getCampaignDisplayStatus({
    status: conversationStatus,
    campaignType,
    meetingBookingStatus
  });

  if (acceptedStatuses.includes(status)) {
    return {
      label: 'Satisfied',
      color: 'success',
      icon: <CheckIcon fontSize="small" />,
      sx: badgeChipSx
    };
  }

  if (rejectedStatuses.includes(status)) {
    return {
      label: 'Not satisfied',
      color: 'error',
      icon: <CloseIcon fontSize="small" />,
      sx: badgeChipSx
    };
  }

  if (status === ConversationStatus.CompletedNotInterested) {
    return { label: 'Not interested', sx: screeningStatusChipSx.neutralChip };
  }

  if (status === ConversationStatus.Completed) {
    return { label: 'Incomplete', sx: screeningStatusChipSx.neutralChip };
  }

  if (status === ConversationStatus.OptedOut) {
    return {
      label: 'Opted out',
      color: 'error',
      sx: badgeChipSx
    };
  }

  return null;
};

export function ScreeningStatusChip(props: Props) {
  const chipProps = getScreeningStatusChipProps(props);

  return chipProps && <Chip {...chipProps} />;
}
